<template>
  <!-- red oglasa u blokovima (Top oglasi, Najnoviji, kategorije, bocne kolone); stilovi: assets/scss/adRow.scss -->
  <article class="adr noselect" :class="{ 'adr-noimg': !showImage }">
    <NuxtImg
      v-if="showImage"
      :src="$getImageSrc(ad.img)"
      fit="cover"
      width="60"
      height="60"
      loading="lazy"
      decoding="async"
      :alt="ad.title + ' – pregled cena na pijacama'"
      class="adr-img"
    />

    <!-- jedini link u redu; njegov ::after pokriva ceo red, pa je klikabilna i slika, mesto i cena -->
    <div class="adr-title">
      <NuxtLink :to="link" class="adr-link">{{ ad.title }}</NuxtLink>
    </div>

    <button
      type="button"
      class="adr-heart"
      :class="{ 'adr-heart-on': customerStore.loggedIn && followed }"
      aria-label="Prati oglas"
      @click="onToggleFollow"
    ></button>

    <span class="adr-meta">{{ ad.place_name }}<span v-if="ad.lawyer == 1" class="adr-tz"><i class="esei icon-store-solid" aria-hidden="true"></i>Tezga</span></span>

    <span class="adr-pill">
      {{ displayPrice(ad.price_type, ad.price) }}
      <span>{{ currencySymbol(ad.price_type, ad.currency_code) }}</span>
    </span>
  </article>
</template>

<script setup>
import { useCustomerLoginStore } from '~/stores/login/customer'

const props = defineProps({
  advertisement: { required: true, type: Object },
  // false: red bez slike (npr. Najnoviji oglasi)
  showImage: { type: Boolean, default: true },
})

const { $srbTolat } = useNuxtApp()
const customerStore = useCustomerLoginStore()

const { displayPrice, currencySymbol } = usePriceFormat()
const { followed, syncFollowedFromFollowers, toggleFollow } = useAdFollowers()

const ad = computed(() => props.advertisement)

const link = computed(() => ({
  name: 'oglas-title-id',
  params: { title: ad.value.slug || $srbTolat.srbTolat(ad.value.title), id: ad.value.id },
}))

const onToggleFollow = async () => {
  if (!ad.value?.id) return
  await toggleFollow(ad.value.id)
}

// inicijalno + kad se promeni korisnik ili lista pratilaca
watch(
  () => [ad.value?.follower_id, customerStore.customer?.id],
  () => syncFollowedFromFollowers(ad.value?.follower_id),
  { immediate: true }
)
</script>
